import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { withRouter } from "react-router";
import { setFormActiveScreen, setDetails } from "../pre-delivery-inspection-lead-form-parent/actions";
import { fetchModelImg, getQuestionForUserIntent } from "./actions";

const mapStateToProps = ({
    preDeliveryInspectionLeadData,
    user: {isLoggedIn}
}) => ({
    preDeliveryInspectionLeadData,
    isLoggedIn
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setFormActiveScreenConnect: setFormActiveScreen,
    setDetailsConnect: setDetails,
    getQuestionForUserIntentConnect: getQuestionForUserIntent,
    fetchModelImgConnect: fetchModelImg
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));
